import { defineStore } from "pinia";
import { portalConfigService } from "@/_services";

export const logoListStore = defineStore("logoStore", {
  state: () => ({
    sendLogo: null,
    logo: null,
    error: null,
  }),
  actions: {
    saveLogo(data) {
      const payload = {
        logo: data.logo || "",
        icon: data.icon || "",
      };

      this.sendLogo = null;
      this.error = null;
      return portalConfigService
        .saveLogo(payload)
        .then((result) => {
          this.sendLogo = result;
          this.logo = {
            ...this.logo,
            ...payload,
          };
          return result;
        })
        .catch((reason) => {
          this.sendLogo = false;
          this.error = reason;
          throw reason;
        });
    },
    clearLogo() {
      this.logo = null;
    },
    setLocalLogo(data) {
      this.logo = {
        ...this.logo,
        logo: data.logo || "",
        icon: data.icon || "",
      };
    },
    getLogo() {
      this.error = null;
      return portalConfigService
        .getLogo()
        .then((result) => {
          if (result && typeof result === "object" && !Array.isArray(result)) {
            this.logo = result;
          }
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
